module.exports = __webpack_public_path__ + "img/cam4.c3d0a1a.png";